import React from 'react';

export default function FieldError({ message, className = '' }) {
  if (!message) return null;
  return (
    <p
      role="alert"
      className={`mt-1.5 text-left text-xs font-medium text-red-600 ${className}`}
    >
      {message}
    </p>
  );
}

export function ButtonSpinner({ className = '' }) {
  return (
    <span
      className={`inline-block h-3.5 w-3.5 animate-spin rounded-full border-2 border-white/40 border-t-white ${className}`}
      aria-hidden
    />
  );
}
